"use client";

import { useQuery } from "@tanstack/react-query";

import type { CalendarEntryWithRecipe } from "@/lib/calendar/server";
import { localToday } from "@/lib/calendar/week";

interface CalendarResponse {
  entries: CalendarEntryWithRecipe[];
  weekStart: string;
  weekEnd: string;
}

export function useCalendar(weekOf: string | undefined, locale: string, enabled: boolean) {
  return useQuery<CalendarResponse>({
    queryKey: ["calendar", weekOf, locale],
    queryFn: async () => {
      const params = new URLSearchParams({ locale, today: localToday() });
      if (weekOf) params.set("weekOf", weekOf);
      const res = await fetch(`/api/calendar?${params}`);
      if (!res.ok) throw new Error("Failed to fetch calendar");
      return res.json();
    },
    enabled,
  });
}
